const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Obtener prendas de clientes con filtros y paginación
 */
export const getClientGarments = async (filters = {}) => {
  try {
    const { query = {}, page = 1, limit = 10 } = filters;
    
    const response = await fetch(`${API_URL}/client-garments/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        page,
        limit,
      }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener las prendas de clientes');
    }

    const result = await response.json();
    
    // El backend devuelve { state, data, totalRecords } en lugar de { success, data }
    // Normalizar la respuesta para que sea consistente
    return {
      data: result.data || [],
      totalRecords: result.totalRecords || 0,
      totalPages: result.totalPages || 0,
      currentPage: result.currentPage || page,
    };
  } catch (error) {
    console.error('Error al obtener prendas de clientes:', error);
    throw error;
  }
};

/**
 * Crear nueva prenda de cliente
 */
export const createClientGarment = async (garmentData) => {
  try {
    const response = await fetch(`${API_URL}/client-garments/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(garmentData),
    });

    if (!response.ok) {
      throw new Error('Error al crear la prenda');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al crear prenda:', error);
    throw error;
  }
};

/**
 * Actualizar prenda de cliente
 */
export const updateClientGarment = async (id, garmentData) => {
  try {
    const response = await fetch(`${API_URL}/client-garments/update/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(garmentData),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar la prenda');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al actualizar prenda:', error);
    throw error;
  }
};

/**
 * Eliminar prenda de cliente
 */
export const deleteClientGarment = async (id) => {
  try {
    const response = await fetch(`${API_URL}/client-garments/delete/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al eliminar la prenda');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al eliminar prenda:', error);
    throw error;
  }
};

/**
 * Exportar prendas de clientes
 */
export const exportClientGarments = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/client-garments/export`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query: filters }),
    });

    if (!response.ok) {
      throw new Error('Error al exportar las prendas');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `prendas_clientes_${new Date().toISOString().split('T')[0]}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

    return { success: true };
  } catch (error) {
    console.error('Error al exportar prendas:', error);
    throw error;
  }
};

/**
 * Asignar prendas a un cliente
 */
export const assignGarmentsToClient = async (clientId, garments) => {
  try {
    const response = await fetch(`${API_URL}/client-garments/assign`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        clientId,
        garments,
      }),
    });

    if (!response.ok) {
      throw new Error('Error al asignar prendas al cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al asignar prendas:', error);
    throw error;
  }
};

/**
 * Obtener prendas asignadas a un cliente
 */
export const getClientAssignedGarments = async (clientId) => {
  try {
    const response = await fetch(`${API_URL}/client-garments/client/${clientId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener las prendas del cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al obtener prendas del cliente:', error);
    throw error;
  }
};

/**
 * Actualizar prendas asignadas cuando se edita una prenda base
 */
export const updateAssignedGarmentsFromBase = async (garmentId, garmentData) => {
  try {
    const response = await fetch(`${API_URL}/client-garments/update-from-base/${garmentId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(garmentData),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar las asignaciones de prendas');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al actualizar asignaciones:', error);
    throw error;
  }
};
